import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./style.css";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

THREE.ColorManagement.enabled = false;
let model;

/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvasQuestion = document.querySelector("canvas.webglQuestion");

// Scene
const scene = new THREE.Scene();
// scene.background = new THREE.Color("#000000");

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");

const gltfLoader = new GLTFLoader();

gltfLoader.setDRACOLoader(dracoLoader);

let mixer = null;

const textureLoader = new THREE.TextureLoader();

gltfLoader.load("/model/dryLeaf/scene.gltf", (gltf) => {
    model = gltf.scene;
    model.scale.set(1, 1, 1);
    model.position.y = 0;
    model.position.z = 0;
    model.position.x = -1;
    model.rotation.set(0.5, -0.5, 0);
  
    scene.add(model);
    gsap.registerPlugin(ScrollTrigger);
  
    ScrollTrigger.defaults({
      immediateRender: false,
      ease: "power1.inOut",
    });
  
    let questionMove = gsap.timeline({
      scrollTrigger: {
        trigger: ".webglQuestion",
        start: "top top",
        end: "230% bottom",
        scrub: 1,
        pin: true,
        // markers: true,
      },
    });
  
    questionMove.to(model.rotation, { y: -1.5, duration: 1 }, 'runSame');
    questionMove.to(model.position, { x: 1.5, duration: 1 },'runSame');
    questionMove.to(model.position, { x: -4, duration: 1 }, 'runSame2');
    questionMove.to(model.rotation, { y: -2.5, duration: 1 }, 'runSame2');
    questionMove.to(model.position, { x: 1.5, duration: 1 }, 'runSame3');
    questionMove.to(model.rotation, { x: -1.5, duration: 1 }, 'runSame3');



  });
  

const ambientLight = new THREE.AmbientLight(0xffffff, 0.25);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
directionalLight.shadow.mapSize.set(10, 10);

directionalLight.position.set(5, 5, 5);
scene.add(directionalLight);

/* Sizes*/
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(0, 2, 5);

scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvasQuestion);
controls.enableDamping = true;
controls.enableZoom = false;

/* Renderer */
const renderer = new THREE.WebGLRenderer({
  canvas: canvasQuestion,
  alpha: true,
});
renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  controls.update();
  renderer.render(scene, camera);

  window.requestAnimationFrame(tick);
};

tick();



gsap.registerPlugin(ScrollTrigger);

let questionMove = gsap.timeline({
    scrollTrigger: {
      trigger: ".webglQuestion",
      start: "top top",
      end: "250% bottom",
      scrub: 1,
    },
  });

  questionMove
    .to(".showFirstWhatWeDo", {opacity:1, duration:1 })
    .to(".showSecondWhatWeDo", {opacity:1, duration:1 })
    .to(".showThirdWhatWeDo", {opacity:1, duration:1 })

